import { DEFAULT_ANTI_SPIDER, METRIC_NAME, METRIC_NAME_MONITOR_JS_LOAD_TIME, METRIC_NAME_REWRITE } from '@/constants/index.ts';
import GlobalVariables, { GLOBAL_VARIABLES } from './global.ts';

export const fetchWithRetries = async (url: string, options: RequestInit = {}, maxRetries: number = 1, backoff: number = 1000): Promise<Response | any> => {
  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      return await fetch(url, options)
    } catch (error) {
      if (attempt === maxRetries - 1) throw error;
      await new Promise(r => setTimeout(r, backoff * Math.pow(2, attempt)))
    }
  }
}

export const rewriteFetch = () => {
  if (typeof window !== 'undefined') {
    const originalFetch = window.fetch;
    window.fetch = async function (input, init = {}) {
      let url = input as string;
      let options = init;
      // 如果 input 是一个 Request 对象，而非字符串 URL，则需要解析
      if (input instanceof Request) {
        url = input.url;
        options = {
          method: input.method,
          headers: new Headers(input.headers),
          body: input.body,
          mode: input.mode,
          credentials: input.credentials,
          cache: input.cache,
          redirect: input.redirect,
          referrer: input.referrer,
          integrity: input.integrity,
        };
      }
      // 确保 headers 存在
      if (!options.headers) {
        options.headers = new Headers();
      } else if (!(options.headers instanceof Headers)) {
        options.headers = new Headers(options.headers);
      }
      try {
        const hit = DEFAULT_ANTI_SPIDER?.anti_in?.hit || []
        const globalHit = GlobalVariables?.get(GLOBAL_VARIABLES.ANTI_HIT) || []
        const hits = Array.from(new Set([...hit, ...globalHit]))
        const antiIn = await getAntiIn()
        if (antiIn && hits?.some(path => url.includes(path))) {
          options.headers.set('anti-in', antiIn);
        }
        // if (GlobalVariables.get(GLOBAL_VARIABLES.API_PATHS).some((path: string) => url?.includes(path))) {
        if (isInSite(url)) {
          let channel = GlobalVariables.get(GLOBAL_VARIABLES.CHANNEL)
          if (channel == 0 || channel == 1) {
            // pc pwa
            const at = getArmorToken() || ''
            if (at) {
              options.headers.set('armorToken', at);
            }
          } else {
            // h5
            const at = window?.appComParams?.armorToken || window?.appComParams?.armortoken || window?.appComParams?.ArmorToken || window._s_ArmorToken || ''
            if (at) {
              options.headers.set('armorToken', at);
            }
          }
          // 移除域名部分，只保留路径和查询参数
          const { pathname, search } = new URL(url, location.origin);
          const url2 = `${pathname}${search}` || '';
          try {
            if (url2 && window?._SHEIN_CALC_SIGNATURE_) {
              options.headers.set('x-gw-auth', await window._SHEIN_CALC_SIGNATURE_(url2));
            }
          } catch (error) {
            GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
              metric_name: METRIC_NAME,
              tags: { url: url2, type: 'fetchCalcSignatureError' },
              value: Date.now(),
              message: 'Failed to fetch calculate signature',
              params: error
            });
          }
          if (channel == 0 || channel == 1) {
            // pc pwa
            const sm = getSmDeviceId() || '';
            if (sm) {
              options.headers.set('smDeviceId', sm);
            }
          } else {
            // h5
            const sm = window?.appComParams?.SmDeviceId || window?.appComParams?.smDeviceId || window?.appComParams?.smdeviceid || window._s_SmDeviceId || ''
            if (sm) {
              options.headers.set('smDeviceId', sm);
            }
          }
        }
      } catch (error) {
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
          metric_name: METRIC_NAME_REWRITE,
          tags: { type: 'fetchError' },
          value: Date.now(),
          message: 'Failed to rewrite fetch',
          params: error
        });
      }
      const response = await originalFetch(url, options);
      return response;
    };
  }
}

export const rewriteXHR = () => {
  if (typeof window !== 'undefined') {
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function () {
      try {
        const hit = DEFAULT_ANTI_SPIDER?.anti_in?.hit || []
        const globalHit = GlobalVariables?.get(GLOBAL_VARIABLES.ANTI_HIT) || []
        const hits = Array.from(new Set([...hit, ...globalHit]))
        if (hits?.some(path => arguments[1].includes(path))) {
          this._customHeaders = {
            'anti-in': 'anti-in'
          };
        }
        if (isInSite(arguments[1])) {
          let channel = GlobalVariables.get(GLOBAL_VARIABLES.CHANNEL)
          if (channel == 0 || channel == 1) {
            // pc pwa
            const at = getArmorToken() || ''
            if (at) {
              this._customHeaders = {
                ...this._customHeaders,
                'armorToken': at,
              };
            }
          } else {
            // h5
            const at = window?.appComParams?.armorToken || window?.appComParams?.armortoken || window?.appComParams?.ArmorToken || window._s_ArmorToken || ''
            if (at) {
              this._customHeaders = {
                ...this._customHeaders,
                'armorToken': at,
              };
            }
          }
          let sigUrl = arguments[1]
          const url = getSigUrl(sigUrl)
          if (url) {
            this._customHeaders = {
              ...this._customHeaders,
              'x-gw-auth': url
            };

          }
          if (channel == 0 || channel == 1) {
            // pc pwa
            const sm = getSmDeviceId() || '';
            if (sm) {
              this._customHeaders = {
                ...this._customHeaders,
                'smDeviceId': sm
              };
            }
          } else {
            // h5
            const sm = window?.appComParams?.SmDeviceId || window?.appComParams?.smDeviceId || window?.appComParams?.smdeviceid || window._s_SmDeviceId || ''
            if (sm) {
              this._customHeaders = {
                ...this._customHeaders,
                'smDeviceId': sm
              };
            }
          }
        }
      } catch (error) {
        // 捕获所有异常，防止抛出导致请求失败
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
          metric_name: METRIC_NAME_REWRITE,
          tags: { type: 'xhrOpenError' },
          value: Date.now(),
          message: 'Failed to open XHR',
          params: error
        });
      }
      originalOpen.apply(this, arguments as any);
    };
    const originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = async function () {
      try {
        const antiIn = await getAntiIn()
        if (this?._customHeaders?.['anti-in'] && antiIn) {
          this.setRequestHeader('anti-in', antiIn);
        }
        if (this?._customHeaders?.['armorToken']) {
          this.setRequestHeader('armorToken', this?._customHeaders?.['armorToken']);
        }
        try {
          if (this?._customHeaders?.['x-gw-auth'] && window?._SHEIN_CALC_SIGNATURE_) {
            this.setRequestHeader('x-gw-auth', await window._SHEIN_CALC_SIGNATURE_(this?._customHeaders?.['x-gw-auth']));
          }
        } catch (error) {
          GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
            metric_name: METRIC_NAME,
            tags: { url: this?._customHeaders?.['x-gw-auth'], type: 'xhrCalcSignatureError' },
            value: Date.now(),
            message: 'Failed to xhr calculate signature',
            params: error
          });
        }
        if (this?._customHeaders?.['smDeviceId']) {
          this.setRequestHeader('smDeviceId', this?._customHeaders?.['smDeviceId']);
        }
      } catch (err) {
        // 捕获所有异常，防止抛出导致请求失败
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
          metric_name: METRIC_NAME_REWRITE,
          tags: { type: 'xhrSendError' },
          value: Date.now(),
          message: 'Failed to send XHR',
          params: err
        });
      }
      originalSend.apply(this, arguments as any);
    };
  }
}


// get anti-in
export const getAntiIn = async () => {
  const AntiIn = window.AntiIn
  if (!AntiIn) return ''
  if (AntiIn._last) return AntiIn._last
  if (AntiIn._calculating) return await AntiIn._calculating
  let anti_channel: number = 4; // h5
  let channel = GlobalVariables.get(GLOBAL_VARIABLES.CHANNEL)
  if (channel == 0 || channel == 1) {
    // pc pwa
    anti_channel = parseInt(channel)
  }
  AntiIn._calculating = AntiIn.getAllEncrypted(anti_channel)
    .then(_ => {
      AntiIn._calculating = null
      setTimeout(() => AntiIn._last = undefined, 200)
      return AntiIn._last = _
    })
    .catch(() => '')
  return AntiIn._calculating
}

const isInSite = (url: string) => {
  if (!url) {
    return false
  }
  if (DEFAULT_ANTI_SPIDER?.anti_in?.hit?.some((path: string) => url?.includes(path))) {
    // 命中SDK路径
    return true
  }
  // if (/^http(s)?:\/\/www\.srmdata.com/.test(url)) {
  //   return true
  // }
  if (!/^http(s)?:\/\//.test(url)) { // 相对路径
    return true
  }
  const regExp = new RegExp(`^http(s)?://${location.host}`)
  if (regExp.test(url)) { // 本站地址
    return true
  }
  return false
}

const getArmorToken = () => {
  if (window.__ArmorToken) return window.__ArmorToken;
  window.__ArmorToken = window?.localStorage?.getItem('armorToken') || '';
  return window.__ArmorToken;
}

const getSmDeviceId = () => {
  if (window.__SmDeviceId) return window.__SmDeviceId;
  window.__SmDeviceId = window?.localStorage?.getItem('SmDeviceId') || '';
  return window.__SmDeviceId;
}

const getSigUrl = (url: string) => {
  // let sigUrl = url
  // let _query = sigUrl?.split('?')?.[1]?.replace(/'/g, '%27') || ''
  // if (_query) {
  //   sigUrl = sigUrl?.split('?')?.[0] + '?' + _query
  // } else {
  //   sigUrl = sigUrl?.split('?')?.[0]
  // }
  // return sigUrl
  const { pathname, search } = new URL(url, location.origin);
  return `${pathname}${search}` || '';
}

export const fetchJsonSafe = async (url: string, opts = {}) => {
  const res = await fetch(url, opts);
  if (!res.ok) {
    const raw = await res.text().catch(() => '[unreadable body]');
    const err: any = new Error(`HTTP ${res.status} ${res.statusText}`);
    err.status = res.status;
    err.raw = raw;
    throw err;
  }

  // 检查 content-type 是否声明为 JSON
  const ct = (res.headers.get('content-type') || '').toLowerCase();
  if (!ct.includes('application/json')) {
    const raw = await res.text().catch(() => '[unreadable body]');
    const err: any = new Error('Response is not application/json');
    err.raw = raw;
    err.contentType = ct;
    err.status = res.status;
    throw err;
  }

  try {
    const r = { response: await res.json(), status: res.status }
    return r;
  } catch (parseErr: any) {
    // res.json() 失败时，使用 clone() 读取原始文本
    const raw = await res.clone().text().catch(() => '[unreadable body]');
    const err: any = new Error('Invalid JSON response: ' + parseErr.message);
    err.original = parseErr;
    err.raw = raw;
    err.status = res.status;
    throw err;
  }
}

export const monitorSingleJsLoadTime = (keyword: string, assistName: string) => {
  if (!window.performance || !window.performance.getEntriesByType) return;
  const time = Date.now();
  const scriptEntries = window.performance.getEntriesByType('resource')
    .filter(entry => (entry as PerformanceResourceTiming).initiatorType === 'script');
  scriptEntries.forEach(entry => {
    const jsName = entry?.name?.split('/')?.slice(-1)?.[0] || '';
    if ((jsName.includes(keyword) && entry.name.includes(assistName))) {
      GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
        metric_name: METRIC_NAME_MONITOR_JS_LOAD_TIME,
        tags: { type: 'mjlt', url: entry.name, name: jsName, duration: entry?.duration?.toFixed(0) },
        value: Date.now() - time,
        message: 'monitorJsLoadTime',
        params: JSON.parse(JSON.stringify(entry || {}))
      })
    }
  });
};